import { render, staticRenderFns } from "./PricesCardBruening.vue?vue&type=template&id=2a375361&"
import script from "./PricesCardBruening.vue?vue&type=script&lang=js&"
export * from "./PricesCardBruening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports